<template>
  <div class="flex flex-col gap-2">
    <div class="flex items-center justify-between">
      <span class="text-xs font-bold uppercase tracking-ds-caps text-muted-foreground">{{ caption }}</span>
      <span class="text-xs font-semibold text-muted-foreground/50">{{ counts.enabled }} of {{ counts.total }}</span>
    </div>
    <PivotFieldGroup
      v-model="modelValue"
      :group
      :section
      :readonly
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { PivotTableConfig, PivotTableGroup } from '@types'

import { getSectionCounts } from './utils'

import PivotFieldGroup from './PivotFieldGroup.vue'

type Props = {
  caption: string
  group?: string
  section: PivotTableGroup
  readonly?: boolean
}

const { section } = defineProps<Props>()

const modelValue = defineModel<PivotTableConfig>()

const counts = computed(() => getSectionCounts(modelValue.value?.fields, section))
</script>
